import { Box } from '@mui/material';
import LocationCard from './LocationCard/LocationCard';

const DashboardEquipmentChartsContainer = ({ fixtures, matHandling }) => {
  const dashboardContainerStyles = {
    display: 'flex',
    width: '100%',
    gap: '20px',
    '.alertsCard': {
      minWidth: '190px',
    },
  };

  return (
      <Box sx={dashboardContainerStyles}>
        <LocationCard fixtures={fixtures} matHandling={matHandling} />
      </Box>
  );
};

export default DashboardEquipmentChartsContainer;
